module.exports = __webpack_public_path__ + "fonts/ActaDisplay-Medium.cb20edba.otf";